<div class="flex flex-col gap-4">
    <vui-progress-bar [mode]="'determinate'" [progress]="40"></vui-progress-bar>

    <vui-progress-bar [mode]="'indeterminate'"></vui-progress-bar>

    <vui-progress-spinner [mode]="'determinate'" [progress]="70"></vui-progress-spinner>
    <vui-progress-spinner [mode]="'indeterminate'"></vui-progress-spinner>
</div>
